import React, { useCallback } from 'react';
var Navigator = function (_a) {
    var currentSlide = _a.currentSlide, instanceRef = _a.instanceRef, thumbnails = _a.thumbnails, thumbSize = _a.thumbSize, navigatorSide = _a.navigatorSide;
    var renderThumbnails = useCallback(function (tn, idx) {
        var selected = currentSlide === idx ? 'selected' : '';
        return (React.createElement("div", { key: idx, 
            // This is already memoized by useCallback
            // eslint-disable-next-line react/jsx-no-bind
            onClick: function () { var _a; return (_a = instanceRef.current) === null || _a === void 0 ? void 0 : _a.moveToIdx(idx); }, className: "thumbnail ".concat(thumbSize, " ").concat(selected) }, tn));
    }, [currentSlide, instanceRef, thumbSize]);
    return (React.createElement("div", { className: "thumbnails-container" },
        React.createElement("div", { className: "thumbnails ".concat(navigatorSide) }, !!(thumbnails === null || thumbnails === void 0 ? void 0 : thumbnails.length) && thumbnails.map(renderThumbnails))));
};
export default Navigator;
//# sourceMappingURL=Navigator.js.map